module.exports = __webpack_public_path__ + "components/country-flag/static/je-2cd7c818cf56350d0e6018535c4b7636.svg";